import Vue from 'vue'
import Vuex from 'vuex'
import auth from './modules/auth'
import lang from './modules/lang'
import api from './modules/api'
import exporterApi from './modules/exporterApi'
import importerApi from './modules/importerApi'
import verificationApi from './modules/verificationApi'
import BaseStore from './base'

Vue.use(Vuex)

export default new Vuex.Store(Object.assign(
    {},
    BaseStore,
    { modules: { auth, lang, api, exporterApi, importerApi, verificationApi } }
))